import { render, staticRenderFns } from "./delivery-pick.vue?vue&type=template&id=f0ae1bc0&scoped=true"
import script from "./delivery-pick.vue?vue&type=script&lang=js"
export * from "./delivery-pick.vue?vue&type=script&lang=js"
import style0 from "./delivery-pick.vue?vue&type=style&index=0&id=f0ae1bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ae1bc0",
  null
  
)

export default component.exports